import React, {useEffect} from 'react';
import {connect} from "react-redux";
import PDLBorder from "../../components/PDLBorder";
import Logo from "../../components/Logo";
import '../../assets/css/profile.css';
import AuthHeader from "../../components/AuthHeader";
import Rulebook from '../../assets/img/Rulebook.png';
import {getCharactersRequest, getPagesRequest, setLoader} from "../../redux/Site/action";


const NotFound = (props) => {


    return (
        <section className="fram-sec">
            <div className="frame-wrapper">

                {/* Border*/}
                <PDLBorder/>
                {/*Logo*/}
                <Logo/>

                {/*Menus*/}
                <div className="row">
                    {/*<div className="col-md-12">*/}

                    {/*</div>*/}
                    <div className="col-md-12">
                        <div className="Menus text-right">
                            <AuthHeader/>
                        </div>
                    </div>
                </div>
                {/*Menus*/}

                <section className="profile">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-2">

                            </div>
                            <div className="col-lg-8">
                                <div className="profile-creation text-center">
                                    <figure>
                                        <h3 className={"mb-5 pdlStyleHeading"}>{ props?.content? props?.content : 'Page Not Found' }</h3>
                                    </figure>
                                    <p className={"pdlStyleParagraph"}>
                                    </p>
                                </div>

                            </div>
                            <div className="col-lg-2"></div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    );
}

const mapStateToProps = (state) => {
    return {

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(NotFound);